import { Container, Graphics, Text } from 'pixi.js'
import { DropShadowFilter } from '@pixi/filter-drop-shadow'
import type { BulletStyle } from '@/scripts/config/settings'

export function createLabelContainer(
  text: string,
  isLeft: boolean,
  style: BulletStyle,
): {
  container: Container
  labelXPos: number
} {
  const labelContainer = new Container()
  labelContainer.visible = false

  const labelBackground: Graphics = new Graphics()
  labelBackground.lineStyle(2, style.BULLET_LABEL_STROKE_COLOR)
  labelBackground.beginFill(style.BULLET_LABEL_BACKGROUND_COLOR, style.BULLET_LABEL_BACKGROUND_ALPHA)
  labelBackground.drawRoundedRect(0, 0, style.LABEL_WIDTH, style.LABEL_HEIGHT, 100)
  labelBackground.endFill()
  labelBackground.y = -style.LABEL_HEIGHT / 2
  labelContainer.filters = [
    new DropShadowFilter({
      color: 0x306d84,
      pixelSize: 2,
      offset: { x: 2, y: 2 },
      resolution: 2,
      quality: 20,
      alpha: 0.25,
      blur: 0,
    }),
  ]
  labelContainer.addChild(labelBackground)

  const labelText: Text = new Text('', {
    fontFamily: style.FONT_BASE,
    fontWeight: '500',
    fontSize: '16px',
    fill: style.BULLET_LABEL_TEXT_COLOR,
  })
  if (isLeft) {
    labelText.x = -style.LABEL_TEXT_X_OFFSET
    labelText.anchor.x = 1.0
  } else {
    labelText.x = style.LABEL_TEXT_X_OFFSET
  }
  labelText.anchor.y = 0.5
  labelText.y = labelBackground.y + style.LABEL_HEIGHT / 2
  labelContainer.addChild(labelText)

  const labelMask: Graphics = new Graphics()
  labelMask.beginFill(0x000000, 1.0)
  if (isLeft) {
    labelMask.drawRect(-style.LABEL_WIDTH, -(style.LABEL_HEIGHT + 4) / 2, style.LABEL_WIDTH, style.LABEL_HEIGHT + 4)
  } else {
    labelMask.drawRect(0, -(style.LABEL_HEIGHT + 4) / 2, style.LABEL_WIDTH, style.LABEL_HEIGHT + 4)
  }
  labelMask.endFill()

  labelText.text = text.toUpperCase()
  labelText.updateText(true)

  if (isLeft) {
    labelBackground.x = -labelText.width - style.LABEL_TEXT_X_OFFSET - style.LABEL_TEXT_X_PADDING
  } else {
    labelBackground.x = -style.LABEL_WIDTH + labelText.width + style.LABEL_TEXT_X_OFFSET + style.LABEL_TEXT_X_PADDING
  }

  const labelXPos = labelText.width + style.LABEL_TEXT_X_OFFSET + style.LABEL_TEXT_X_PADDING
  const finalLabelXPos = isLeft ? labelXPos : -labelXPos

  labelContainer.x = finalLabelXPos

  return { container: labelContainer, labelXPos: finalLabelXPos }
}
